import { useHideSystemCursor } from '../hooks'

export function HideDefaultCursor() {
  useHideSystemCursor()

  return null
}
